export default __webpack_public_path__ + "static/media/title_2.383ab8fc.png";